import ModelFactory from '../model-factory';

export default class Bopsid {
  constructor(opts = {}) {
    this.bopsid = opts.bopsid_val || null;
  }
}

export const modelFactory = new ModelFactory('bopsid', (data) => new Bopsid(data));
